/*
  Best sellers / My picks carousel (sections/hp-best-sellers.liquid).

  Needs EmblaCarousel from embla-slider-min.js, which layout/theme.liquid
  loads in the head. homepage-custom.js skips .embla--picks so the two
  scripts never set up the same carousel.
*/
(function () {
  function initPicksCarousel(wrapperNode) {
    if (wrapperNode.dataset.emblaInitialized === 'true') return;

    const viewportNode = wrapperNode.querySelector('.embla__viewport');
    if (!viewportNode || typeof EmblaCarousel === 'undefined') return;

    wrapperNode.dataset.emblaInitialized = 'true';

    const loopEnabled = wrapperNode.dataset.loop !== 'false';

    const emblaApi = EmblaCarousel(viewportNode, {
      loop: loopEnabled,
      align: 'start',
      slidesToScroll: 1,
    });

    const prevButtonNode = wrapperNode.querySelector('.embla__prev');
    const nextButtonNode = wrapperNode.querySelector('.embla__next');

    const updateNavButtons = () => {
      if (!prevButtonNode || !nextButtonNode) return;

      if (loopEnabled && emblaApi.scrollSnapList().length > 1) {
        prevButtonNode.disabled = false;
        nextButtonNode.disabled = false;
        return;
      }

      prevButtonNode.disabled = !emblaApi.canScrollPrev();
      nextButtonNode.disabled = !emblaApi.canScrollNext();
    };

    prevButtonNode?.addEventListener('click', () => emblaApi.scrollPrev());
    nextButtonNode?.addEventListener('click', () => emblaApi.scrollNext());

    emblaApi.on('select', updateNavButtons);
    emblaApi.on('reInit', updateNavButtons);
    updateNavButtons();
  }

  function initAll(root) {
    root.querySelectorAll('.embla--picks').forEach(initPicksCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }

  // The theme editor swaps in fresh markup when the section's settings change.
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
